import React, { useState, useEffect } from "react"
import { useStripe, useElements, IbanElement } from "@stripe/react-stripe-js"
import IbanForm from "./ibanForm"
import { Modal, Button } from "react-bootstrap"
import { useStaticQuery, graphql } from "gatsby"
import emailjs from "emailjs-com"
import $ from "jquery"

export default function CheckoutForm({ planamount, planname }) {
  const data = useStaticQuery(graphql`
    query {
      allContentfulTestDrivePlans(sort: { fields: createdAt }) {
        nodes {
          buttonTwo
          thankYouTextOne
          thankYouTextTwo
        }
      }
    }
  `)
  const { allContentfulTestDrivePlans } = data

  const stripe = useStripe()
  const elements = useElements()

  const [visible, setVisible] = useState(false)
  const [visible2, setVisible2] = useState(false)

  const handleShow = () => setVisible2(true)
  const handleClose = () => setVisible(false)

  const testPlanNotification = e => {
    if (planname != "Once off payment") {
      e.preventDefault()
      emailjs
        .sendForm(
          "service_qkbep48",
          "template_6tdwkww",
          e.target,
          "user_H1giHzeT00K7WW4tInQOn"
        )
        .then(
          result => {
            console.log(result)
          },
          error => {
            console.log(error.text)
          }
        )
    } else {
      e.preventDefault()
    }
  }

  useEffect(() => {
    // center popup box on screen
    $(".modal-dialog").addClass("modal-dialog-centered")
  })

  const handleSubmit = async event => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault()

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return
    }

    var amount = planamount
    if (amount.charAt(0) === "€") {
      amount = amount.substring(1, amount.length)
    } else {
      amount = amount.substring(0, amount.length)
    }
    amount = parseInt(amount) * 100

    const iban = elements.getElement(IbanElement)

    const accountholderName = event.target["accountholder-name"]
    const companyName = event.target["company-name"]
    const email = event.target.email

    bankTransfer()

    async function bankTransfer() {
      const paymentData = {
        accountholderName: accountholderName.value,
        name: companyName.value,
        email: email.value,
        planType: planname,
        amount: amount,
      }

      const res = await fetch("/.netlify/functions/bank-transfer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paymentData),
      })
        .then(response => response.json())
        .then(handleResponse)
    }
  }

  async function handleResponse(json) {
    const iban = elements.getElement(IbanElement)

    sendToDatabase()

    async function sendToDatabase() {
      const paymentData = {
        name: json.name,
        email: json.email,
        planType: planname,
        payment: "sepa",
      }

      const response = await fetch("/.netlify/functions/store-customer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paymentData),
      })

      return response.json()
    }

    stripe.confirmSepaDebitPayment(json.secret, {
      payment_method: {
        sepa_debit: iban,
        billing_details: {
          name: json.name,
          email: json.email,
        },
      },
    })

    handleClose()
    handleShow()
  }

  return (
    <div>
      <div>
        <form onSubmit={testPlanNotification}>
          <div className="form-group">
            <label className="sr-only">Plan name</label>
            <input value={planname} type="hidden" name="plan_name" />
          </div>
          <Button
            type="submit"
            className="btn btn-primary"
            onClick={() => setVisible(true)}
          >
            {allContentfulTestDrivePlans.nodes[0].buttonTwo}
          </Button>
        </form>

        <Modal
          show={visible}
          onHide={() => setVisible(false)}
          className="main-text-color"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {allContentfulTestDrivePlans.nodes[0].buttonTwo}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <IbanForm
              onSubmit={handleSubmit}
              disabled={!stripe}
              planname={planname}
              planamount={planamount}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={visible2}
          onHide={() => setVisible2(false)}
          className="main-text-color"
        >
          <Modal.Header closeButton>
            {allContentfulTestDrivePlans.nodes[0].thankYouTextOne}
          </Modal.Header>
          <Modal.Body>
            {allContentfulTestDrivePlans.nodes[0].thankYouTextTwo}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  )
}
